import { defineMessages } from 'react-intl';
import type { AzureExperienceEnum } from '@foundershub/api-client';

export const azureExperienceLabels = defineMessages<AzureExperienceEnum>({
  'never-built-on-azure': {
    defaultMessage: 'Never built on Azure',
    description: '{Locked="Azure"}, experience with Microsoft Azure',
  },
  'moderately-familiar': {
    defaultMessage: 'Moderately familiar',
    description: 'experience with Microsoft Azure',
  },
  'expert-with-azure': {
    defaultMessage: 'Expert with Azure',
    description: '{Locked="Azure"}, experience with Microsoft Azure',
  },
});
